import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import { useIsFirstRender } from '../../../hooks/isFirstRender';
import Translator from '../../components/helpers/Translator';
import _ from 'lodash';

const ObligationFormQuestionSelect = (props) => {
  const { question, questionIndex, checkedQuestions, onChange } = props;
  const isFirstRender = useIsFirstRender();
  const actualLang = useSelector((state) => state.global.urlData.lang);
  const [isChecked, setIsChecked] = useState(
    checkedQuestions && checkedQuestions[question.code] !== undefined
  );

  const getConditionsOptions = () => {
    let options = [];
    switch (question.type) {
      case 1:
        options = [
          {
            label: ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="no" />
            ),
            value: question.answers[0].code,
          },
          {
            label: ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="yes" />
            ),
            value: question.answers[1].code,
          },
        ];
        break;
      case 2:
      case 3:
      case 4:
      case 6:
        options = question.answers.map((answer) => ({
          label: answer.name || _.values(answer.name),
          value: answer.code,
        }));
        break;
    }

    return options;
  };

  const [options, setOptions] = useState(getConditionsOptions);

  const getDefaultValue = () => {
    // Selected answer
    if (isChecked) {
      if (question.type === 7 && checkedQuestions[question.code]) {
        return checkedQuestions[question.code];
      } else {
        let selectedAnswers = [];
        question.answers.map((answer, i) => {
          if (answer.code === checkedQuestions[question.code]) {
            if (answer.name)
              selectedAnswers = {
                label: answer.name[actualLang] || _.values(answer.name),
                value: answer.code,
              };
            else
              selectedAnswers = {
                label:
                  i === 0
                    ? ReactDOMServer.renderToString(
                        <Translator file="module-legalCompliance" name="no" />
                      )
                    : ReactDOMServer.renderToString(
                        <Translator file="module-legalCompliance" name="yes" />
                      ),
                value: answer.code,
              };
          } else if (checkedQuestions[question.code].includes(answer.code)) {
            selectedAnswers.push({
              label: answer.name[actualLang] || _.values(answer.name),
              value: answer.code,
            });
          }
        });

        return selectedAnswers;
      }
    } else {
      // No selected answer
      switch (question.type) {
        case 1:
          return {
            label: ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="no" />
            ),
            value: question.answers[0].code,
          };
        case 2:
        case 4:
        case 6:
          return {
            label:
              question.answers[0].name || _.values(question.answers[0].name)[0],
            value: question.answers[0].code,
          };
        default:
          return undefined;
      }
    }
  };

  const [value, setValue] = useState(getDefaultValue);

  useEffect(() => {
    if (!isFirstRender) {
      let answerCodes = undefined;
      if (value)
        answerCodes = Array.isArray(value)
          ? _.map(value, 'value')
          : typeof value === 'object'
          ? value.value
          : value;
      onChange(answerCodes);
    }
  }, [value]);

  return (
    <div>
      {question.type !== 5 && question.type !== 7 && (
        <Select
          className="mb-3"
          options={options}
          onChange={(opt) => setValue(opt)}
          value={value}
          isMulti={question.type === 3}
          closeMenuOnSelect={question.type !== 3}
          placeholder={ReactDOMServer.renderToString(
            <Translator file="module-legalCompliance" name="select.responses" />
          )}
        />
      )}
      {question.type === 7 && (
        <Form.Control
          as="textarea"
          rows="3"
          value={value}
          onChange={(opt) => setValue(opt.target.value)}
        />
      )}
    </div>
  );
};

export default ObligationFormQuestionSelect;
